import { createReducer, on } from "@ngrx/store";
import { updateLoaderState } from "../actions/global.action";


const initialLoaderState: boolean = false;
export const globalLoaderReducer = createReducer(
  initialLoaderState,
  on(updateLoaderState, (_, action) => action.isLoading),
);